import { render, staticRenderFns } from "./Punti.vue?vue&type=template&id=478e7e08&scoped=true&"
import script from "./Punti.vue?vue&type=script&lang=js&"
export * from "./Punti.vue?vue&type=script&lang=js&"
import style0 from "./Punti.vue?vue&type=style&index=0&id=478e7e08&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478e7e08",
  null
  
)

export default component.exports